module.exports={
	"Form": "ObservationManifestViewManifest",
	"Scope": "ObservationManifest-View",
	"Descriptors":
	{
		"ObservationManifestDetails.IDObservationManifest":
		{
			"Name": "ID",
			"Hash": "ObsManifestView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsManifestIdentity",
				"Group": "ObsManifestIdentity"
			}
		},
		"ObservationManifestDetails.GUIDObservationManifest":
		{
			"Name": "GUID",
			"Hash": "ObsManifestView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsManifestIdentity",
				"Group": "ObsManifestIdentity"
			}
		},
		"ObservationManifestDetails.Name":
		{
			"Name": "Name",
			"Hash": "ObsManifestView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ObsManifestIdentity",
				"Group": "ObsManifestIdentity"
			}
		},
		"ObservationManifestDetails.DisplayName":
		{
			"Name": "Display Name",
			"Hash": "ObsManifestView-DisplayName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ObsManifestConfig",
				"Group": "ObsManifestConfig"
			}
		},
		"ObservationManifestDetails.Category":
		{
			"Name": "Category",
			"Hash": "ObsManifestView-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ObsManifestConfig",
				"Group": "ObsManifestConfig"
			}
		},
		"ObservationManifestDetails.SettingsJSON":
		{
			"Name": "Settings (JSON)",
			"Hash": "ObsManifestView-Settings",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "ObsManifestSettings",
				"Group": "ObsManifestSettings"
			}
		},
		"ObservationManifestDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ObsManifestView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsManifestAudit",
				"Group": "ObsManifestAudit"
			}
		},
		"ObservationManifestDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ObsManifestView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsManifestAudit",
				"Group": "ObsManifestAudit"
			}
		},
		"ObservationManifestDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ObsManifestView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsManifestAudit",
				"Group": "ObsManifestAudit"
			}
		},
		"ObservationManifestDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ObsManifestView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsManifestAudit",
				"Group": "ObsManifestAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsManifestIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsManifestIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ObsManifestConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ObsManifestConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ObsManifestSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ObsManifestSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ObsManifestAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ObsManifestAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
